var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx, ClassNames } from '@emotion/core';
import { COLORS, FONT } from '../../constants';
var LINK_COLORS = {
  primary: COLORS.blues.primary,
  subtle: COLORS.grays.light,
  light: COLORS.white
};
var LINK_HOVER_COLORS = {
  primary: '#2471b3',
  subtle: COLORS.blues.primary,
  light: COLORS.grays.lighter
};
var LINK_FOCUS_BORDER_COLORS = {
  primary: COLORS.blues.light,
  subtle: COLORS.grays.gray,
  light: COLORS.grays.lighter
};

var linkStyles = function linkStyles(appearance) {
  return __assign(__assign({
    paddingBottom: '2px'
  }, FONT.sizes.regular), {
    fontFamily: FONT.family,
    textAlign: 'left',
    textDecoration: 'none',
    border: '2px solid transparent',
    borderRadius: '2px',
    outline: 'none',
    color: LINK_COLORS[appearance],
    '&:hover, &:focus': {
      color: LINK_HOVER_COLORS[appearance],
      textDecoration: appearance === 'light' ? 'underline' : 'none'
    },
    '&:focus': {
      borderColor: LINK_FOCUS_BORDER_COLORS[appearance]
    },
    '&:visited': {
      color: LINK_COLORS[appearance]
    },
    '&:visited:hover,&:visited:focus': {
      color: LINK_HOVER_COLORS[appearance]
    }
  });
};

var applyTarget = function applyTarget(target) {
  if (target) {
    if (target === '_blank') {
      return {
        target: target,
        rel: 'noopener noreferrer'
      };
    }

    return {
      target: target
    };
  }

  return {};
};

export var Link = function Link(_a) {
  var _b = _a.href,
      href = _b === void 0 ? '' : _b,
      _c = _a.target,
      target = _c === void 0 ? '' : _c,
      _d = _a.children,
      children = _d === void 0 ? '' : _d,
      _e = _a.appearance,
      appearance = _e === void 0 ? 'primary' : _e,
      className = _a.className;
  var appliedTarget = applyTarget(target);
  var styles = linkStyles(appearance); // Use the render props api

  if (typeof children === 'function') {
    return jsx(ClassNames, null, function (_a) {
      var css = _a.css;
      return children(__assign(__assign({}, appliedTarget), {
        className: [css(styles), className].filter(Boolean).join(' '),
        href: href,
        appearance: appearance
      }));
    });
  } // Just render plain old children


  return jsx("a", __assign({
    css: styles,
    className: className,
    href: href
  }, appliedTarget), children);
};